// extracted by mini-css-extract-plugin
export default {"main":"AcademiaPermitidaSelector_main__y4ZD7"};